import React, { ReactElement } from "react";
import styled from "styled-components";

interface Props {
  text: string;
  onClick: any;
}

export default function Button({ text, onClick }: Props): ReactElement {
  return (
    <Container>
      <button className="btn btn-1" onClick={onClick}>
        {text}
      </button>
    </Container>
  );
}

const Container = styled.div`
  .btn {
    border: none;
    cursor: pointer;
    -webkit-transition: all 0.3s;
    -moz-transition: all 0.3s;
    transition: all 0.3s;
  }

  .btn-1 {
    background: #2196f3;
  }

  .btn-1:hover {
    background: #9cbdd8;
  }

  .btn-1:active {
    background: #2196f3;
  }
`;
